import{useRef as r,useEffect as t}from"react";function n(n){var c=r();return t(function(){c.current=n}),c.current}export{n as usePrevious};
//# sourceMappingURL=index.m.js.map
